// extracted by mini-css-extract-plugin
export default {"dateOrTime":"cw47toHBKCHnzdb46ovu","month":"CR7q6iMNwGDom5ua3DBR","literal":"ubX9fkhNLgNAC1K0RjBl","day":"ThKUFziQHZ5QfsTdBBlJ"};